import { render, staticRenderFns } from "./point-info.vue?vue&type=template&id=ced88500&scoped=true"
import script from "./point-info.vue?vue&type=script&lang=js"
export * from "./point-info.vue?vue&type=script&lang=js"
import style0 from "./point-info.vue?vue&type=style&index=0&id=ced88500&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced88500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ced88500')) {
      api.createRecord('ced88500', component.options)
    } else {
      api.reload('ced88500', component.options)
    }
    module.hot.accept("./point-info.vue?vue&type=template&id=ced88500&scoped=true", function () {
      api.rerender('ced88500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/3d/components/point-info.vue"
export default component.exports